import { TTab } from "../index.tsx";
import * as S from "./styles.ts";
import { Button } from "@template/components";

interface ITabLabelsProps {
  tabs: TTab[];
  activeTab: string | number;
  onChange: (tab: string | number) => void;
}

const TabLabels = ({ tabs, activeTab, onChange }: ITabLabelsProps) => {
  return (
    <S.TabLabelsWrapper>
      {tabs.map((tab) => (
        <Button
          key={tab.key}
          disabled={tab.disabled}
          variant={activeTab === tab.key ? "flat" : "light"}
          onClick={() => onChange(tab.key as string)}
          style={{
            width: "100%",
          }}
          color="default"
        >
          {tab.label}
        </Button>
      ))}
    </S.TabLabelsWrapper>
  );
};

export default TabLabels;
